export const UW_ERROR_CODE = 602;
export const ENTITY_NOT_FOUND_ERROR_CODE = 603;
export const POLICYCHANGE_ERROR_CODE = 701;
export const FUNCTIONAL_ERROR_CODE = 702;
export const TECHNICAL_ERROR_CODE = 703;
export const VALIDATION_ERROR_CODE = 704;
export const EMAIL_VALIDATION_ERROR_CODE = 707;
export const POLICY_EXPIRATION_ERROR_CODE = 708;
